import { render, staticRenderFns } from "./InsightPreview.vue?vue&type=template&id=c290fd9c"
import script from "./InsightPreview.vue?vue&type=script&lang=js"
export * from "./InsightPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c290fd9c')) {
      api.createRecord('c290fd9c', component.options)
    } else {
      api.reload('c290fd9c', component.options)
    }
    module.hot.accept("./InsightPreview.vue?vue&type=template&id=c290fd9c", function () {
      api.rerender('c290fd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Insight/InsightPreview.vue"
export default component.exports